// extracted by mini-css-extract-plugin
module.exports = {"link":"_1eXQN","ShinyButtonInverted":"v8kVa","shinyButtonInverted":"v8kVa","labelwrapper":"Wke3U","label":"_1N_aD"};